"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var department_def_1 = require("../../../shared/department.def");
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/department/{department_id}.json', {
    description: 'Get information on a single department',
    method: 'get',
    summary: 'Department Information',
    tags: ['Department'],
    params: [
        {
            $ref: '#/components/parameters/departmentIdPath',
        },
    ],
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: department_def_1.department,
    },
    (0, api_response_def_1.generateValidationError)(),
]);
//# sourceMappingURL=department.get.schema.js.map